import { MapPin, Phone, Mail, Facebook, MessageCircle } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_56a601c8-b253-4088-9fb6-1f7146328396/artifacts/ve1u5sut_logo%20jotuns%20new1.png";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Jotuns Basketball Club" className="h-16" />
              <div>
                <span className="text-xl font-bold text-white tracking-tight" style={{ fontFamily: 'Barlow Condensed' }}>
                  JOTUNS
                </span>
                <span className="block text-xs text-orange-500 tracking-widest">BASKETBALL CLUB</span>
              </div>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Organización deportiva juvenil comprometida con el desarrollo integral de la juventud 
              a través del baloncesto en Sesquilé, Cundinamarca.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 
              className="text-lg font-bold text-white mb-6"
              style={{ fontFamily: 'Barlow Condensed' }}
            >
              CONTACTO
            </h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="https://wa.me/573114540684"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <Phone size={18} />
                  <span>+57 311 454 0684</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:jotunsclubsac2019@gmail.com"
                  className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} />
                  <span>jotunsclubsac2019@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-zinc-400">
                <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                <span>Sesquilé, Cundinamarca<br />Colombia</span>
              </li>
            </ul>
          </div>

          {/* Social & Links */}
          <div>
            <h3 
              className="text-lg font-bold text-white mb-6"
              style={{ fontFamily: 'Barlow Condensed' }}
            >
              SÍGUENOS
            </h3>
            <div className="flex gap-4 mb-8">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-orange-500 rounded-lg flex items-center justify-center text-zinc-400 hover:text-white transition-all"
                data-testid="footer-facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://wa.me/573114540684"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-green-600 rounded-lg flex items-center justify-center text-zinc-400 hover:text-white transition-all"
                data-testid="footer-whatsapp-icon"
              >
                <MessageCircle size={20} />
              </a>
            </div>
            
            <h4 className="text-sm font-semibold text-white mb-3">Enlaces</h4>
            <ul className="space-y-2">
              <li>
                <a href="#inicio" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                  Inicio
                </a>
              </li>
              <li>
                <a href="#nosotros" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#calendario" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                  Calendario
                </a>
              </li>
              <li>
                <a href="/admin" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                  Administración
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            © {currentYear} Jotuns Basketball Club. Todos los derechos reservados.
          </p>
          <p className="text-zinc-600 text-xs">
            Vinculados a la Plataforma Municipal de Juventud de Sesquilé
          </p>
        </div>
      </div>
    </footer>
  );
}
